module.exports = __webpack_public_path__ + "img/reporte_1.dbacb929.svg";